import { DiscoverItemCard } from 'utils/gloo-types';
import Button from 'components/atoms/Button';
import Typography, { TypographyVariants } from 'components/atoms/Typography';
import NullState from 'components/organisms/NullState';
import SkeletonWrap, { SkeletonDiscover } from 'components/organisms/SkeletonWrap';
import { NullStateType } from 'utils/frontendTypes';
import DiscoverCarouselPreview from './DiscoverCarouselPreview';

function DiscoverSectionHeaderPreview({
  wrapperStyleClassName,
  title,
  description,
  nullStateType,
  buttonDurableId,
  isLoading,
  itemCards,
  onViewAll,
  handleCardClick,
  headerVariant,
}: {
  wrapperStyleClassName?: string;
  description?: string;
  title?: string;
  headerVariant?: keyof typeof TypographyVariants;
  nullStateType?: NullStateType;
  isLoading?: boolean;
  buttonDurableId?: string;
  itemCards: DiscoverItemCard[];
  onViewAll?: () => void;
  handleCardClick: (itemCard: DiscoverItemCard) => void;
}) {
  return (
    <div>
      <div className={wrapperStyleClassName || 'pb-8'}>
        <div className="flex flex-row items-end">
          <Typography variant={headerVariant || 'h3'}>{title}</Typography>
          {onViewAll && (
            <Button
              type="transparent"
              className="ml-2 text-charcoal-500 underline font-bold"
              dataDurableId={buttonDurableId}
              text="View All"
              onClick={onViewAll}
            />
          )}
        </div>
        <Typography variant="base" className="font-normal pt-2">
          {description}
        </Typography>
      </div>
      <SkeletonWrap
        isLoading={isLoading}
        skeleton={<SkeletonDiscover />}
        content={
          !itemCards || itemCards.length === 0 ? (
            <NullState type={nullStateType || 'discoverSwimlane'} />
          ) : (
            <DiscoverCarouselPreview onClick={handleCardClick} itemCards={itemCards} />
          )
        }
      />
    </div>
  );
}

export default DiscoverSectionHeaderPreview;
